
import { GenerateReportController } from "./controllers/generatereportcontroller";
import './templates/generatereport.scss';

export function GenerateReportDirective(): ng.IDirective {
    return <ng.IDirective>{
        template: require("./templates/generateReport.html"),
        controller: GenerateReportController,
        controllerAs: "vm",
        scope: true
    }
}

angular
    .module("deliveryCreate.app")
    .directive("generateReport", GenerateReportDirective);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/generateReport/generateReportDirective.ts
 **/